<template>
  <div>
    <h1>Faq</h1>
    <v-btn color="primary" @click="$router.push('/signup')">Get Started</v-btn>
  </div>
</template>

<script>
export default {

  components: {
  },
}
</script>
